import React, { useState, useEffect } from "react";
import "./OrderPayment.css";
import Header from "../common/Header";
import {useNavigate, useLocation, Link} from "react-router-dom";
import httpService from "../../services/HttpService";

const OrderPayment = () => {
    const [showSavedCards, setShowSavedCards] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("При получении");
    const [cards, setCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");  // Error message state
    const orderId = localStorage.getItem("pending_order_id");
    const navigate = useNavigate();
    const location = useLocation();  // Access the location (URL) to get query parameters
    const [order, setOrder] = useState(null);

    // Check query parameters for Success=true
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const fail = params.has("Fail");
        const message = params.get("Message");

        if (fail) {
            setErrorMessage(message || "Не удалось оплатить. Пожалуйста, выберите другую карту или способ оплаты.");
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [location]);

    useEffect(() => {
        const fetchCards = async () => {
            try {
                const data = await httpService.get("/cards").then(response => response.json());
                setCards(data);
                if (data.length > 0) {
                    setSelectedCard(data[0].id);
                }
            } catch (error) {
                console.error("Error fetching cards:", error);
            }
        };

        fetchCards();
    }, []);

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const data = await httpService
                    .get(`/orders/${localStorage.getItem('pending_order_id')}`)
                    .then((response) => response.json());
                setOrder(data);
            } catch (error) {
                console.error("Ошибка при получении данных заказа:", error);
            }
        };

        fetchOrder();
    }, [orderId]);

    const handlePaymentSelection = (paymentMethod) => {
        setSelectedPayment(paymentMethod);
        setShowSavedCards(paymentMethod === "Оплата по карте");
        setErrorMessage("");  // Reset error message when a new payment method is selected
    };

    const handleNewCardClick = async () => {
        setSelectedCard(null);
        setErrorMessage("");

        try {
            const data = await httpService
                .post(`/orders/${orderId}/pay`)
                .then(response => response.json());

            if (data.url?.payment_url) {
                window.location.href = data.url.payment_url;
            } else {
                setErrorMessage("Не удалось оплатить. Пожалуйста, выберите другую карту или способ оплаты.");
                console.error("Payment URL not found in the response");
            }
        } catch (error) {
            setErrorMessage("Не удалось оплатить. Пожалуйста, выберите другую карту или способ оплаты.");
            console.error("Error processing payment:", error);
        }
    };

    const handlePayment = async () => {
        setErrorMessage("");

        try {
            let endpoint = `/orders/${orderId}/pay`;
            const body = {};

            if (selectedPayment === "Оплата по карте") {
                if (selectedCard) {
                    body.card_id = selectedCard;
                }
            } else if (selectedPayment === "Оплата СБП") {
                endpoint = `/orders/${orderId}/pay/sbp`;
            } else {
                return;
            }

            const data = await httpService
                .post(endpoint, body)
                .then((response) => response.json());

            if (data.url?.payment_url) {
                window.location.href = data.url.payment_url;
            } else {
                setErrorMessage("Не удалось оплатить. Пожалуйста, выберите другую карту или способ оплаты.");
                console.error("Payment URL not found in the response");
            }
        } catch (error) {
            setErrorMessage("Не удалось оплатить. Пожалуйста, выберите другую карту или способ оплаты.");
            console.error("Error processing payment:", error);
        }
    };

    const handleFinishOrder = async () => {
        try {
            await httpService.post(`/orders/${orderId}/finish`).then(response => response.json());
            console.log("Order finished successfully!");
            navigate("/orders", {state: {
                message: order.message, 
            }});
        } catch (error) {
            console.error("Error finishing order:", error);
        }
    };


    return (
        <>
            <Header />
            <div className="payment-page-main">
                <div className="pp-order-details-container">
                    <div className="payment-page-heading">Способ оплаты</div>
                    <div className="payment-options">
                        {["При получении", "Оплата по карте", "Оплата СБП"].map((method) => (
                            <div
                                key={method}
                                className={`option ${selectedPayment === method ? "selected" : ""}`}
                                onClick={() => handlePaymentSelection(method)}
                            >
                                <span>{method}</span>
                            </div>
                        ))}
                    </div>

                    {showSavedCards && (
                        <div className="pp-card-list-section">
                            <div className="pp-card-list-container">
                                {cards.map((card) => (
                                    <label key={card.id} className="pp-card-container">
                                        <span className="material-symbols-sharp pp-card-icon">credit_card</span>
                                        <span className="pp-card-pan">Карта **** {card.masked_pan.slice(-4)}</span>
                                        <input
                                            className="pp-card-radio"
                                            type="radio"
                                            name="pp-card-radio"
                                            checked={selectedCard === card.id}
                                            onChange={() => setSelectedCard(card.id)}
                                        />
                                    </label>
                                ))}
                                <label className="pp-card-container" onClick={handleNewCardClick}>
                                    <span className="material-symbols-sharp">add_card</span>
                                    <span className="pp-card-pan">Новая карта</span>
                                    <span className="material-symbols-sharp pp-arrow-forward">arrow_forward_ios</span>
                                </label>
                            </div>
                        </div>
                    )}

                    {errorMessage && (
                        <div className="payment-error-notification">
                            <span>{errorMessage}</span>
                        </div>
                    )}

                    <div className="order-summary">
                        <div className="item"><span>Товар</span><span className="item-right">{order?.amount} ₽</span>
                        </div>
                        {/*<div className="item"><span>Скидка</span><span className="item-right discount">-89 ₽</span></div>*/}
                        <div className="item"><span>Доставка</span><span className="item-right"> {order?.delivery_price ?? 0} ₽</span></div>
                        <div className="total"><span>Итого</span><span
                            className="item-right">{order?.amount + order?.delivery_price} ₽</span></div>
                    </div>
                </div>

                <button className="default-button"
                        onClick={selectedPayment === "При получении" ? handleFinishOrder : handlePayment}>
                    Оформить заказ
                </button>
                <div className="payment-order-contract">Нажимая на кнопку оформить вы соглащаетесь с правилами
                    <Link className="link payment-order-contract-link" to={`/order-contract`}> публичной оферты</Link>
                </div>
            </div>
        </>
    );
};

export default OrderPayment;